import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReviewCompletedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 149,
	height: 149,
	viewBox: "0 0 149 149",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_10312_23782)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M38.3662 23.5H80.875C83.0846 23.5 85.1187 24.3483 86.6455 25.875L109.322 48.5518L109.604 48.8779C110.972 50.5271 111.716 52.4538 111.716 54.5215V126.209C111.716 131.156 107.797 135.076 102.85 135.076H38.3662C33.4189 135.076 29.5 131.156 29.5 126.209V32.3662C29.5 27.4189 33.4189 23.5 38.3662 23.5Z",
				fill: "white",
				stroke: "#E9EAEB"
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#filter1_d_10312_23782)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M85.1472 24.1099V43.8558C85.1472 47.676 88.3822 50.7321 92.0583 50.7321H111.375C110.959 49.8362 110.394 48.9927 109.695 48.2162L86.9995 25.5209C86.4412 24.9627 85.8189 24.4899 85.1472 24.1099Z",
					fill: "#E6E6E6"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_dd_10312_23782)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M121.216 44.5212V116.209C121.216 121.433 117.073 125.576 111.85 125.576H47.3663C42.1428 125.576 38 121.433 38 116.209V22.3663C38 17.1428 42.1428 13 47.3663 13H89.8749C92.2165 13 94.3779 13.9006 95.999 15.5217L118.694 38.217C120.315 40.0182 121.216 42.1796 121.216 44.5212Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M47.3662 13.5H89.875C92.0846 13.5 94.1187 14.3483 95.6455 15.875L118.322 38.5518L118.604 38.8779C119.972 40.5271 120.716 42.4538 120.716 44.5215V116.209C120.716 121.156 116.797 125.076 111.85 125.076H47.3662C42.4189 125.076 38.5 121.156 38.5 116.209V22.3662C38.5 17.4189 42.4189 13.5 47.3662 13.5Z",
				stroke: "#E9EAEB"
			})]
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter3_d_10312_23782)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M94.1472 14.1099V33.8558C94.1472 37.676 97.3822 40.7321 101.058 40.7321H120.375C119.959 39.8362 119.394 38.9927 118.695 38.2162L95.9995 15.5209C95.4412 14.9627 94.8189 14.4899 94.1472 14.1099Z",
				fill: "#E6E6E6"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.2015 59.5237L85.3426 60.7249L87.7975 60.755C89.2248 60.773 90.5404 61.5323 91.2696 62.7593L92.5232 64.8703L94.6342 66.1239C95.8621 66.8531 96.6213 68.1687 96.6385 69.596L96.6686 72.0509L97.8698 74.192C98.568 75.4371 98.568 76.9564 97.8698 78.2015L96.6686 80.3426L96.6385 82.7975C96.6205 84.2248 95.8612 85.5404 94.6342 86.2696L92.5232 87.5232L91.2696 89.6342C90.5404 90.8621 89.2248 91.6213 87.7975 91.6385L85.3426 91.6686L83.2015 92.8698C81.9564 93.568 80.4371 93.568 79.192 92.8698L77.0509 91.6686L74.596 91.6385C73.1687 91.6205 71.8531 90.8612 71.1239 89.6342L69.8703 87.5232L67.7593 86.2696C66.5314 85.5404 65.7722 84.2248 65.755 82.7975L65.7249 80.3426L64.5237 78.2015C63.8254 76.9564 63.8254 75.4371 64.5237 74.192L65.7249 72.0509L65.755 69.596C65.773 68.1687 66.5323 66.8531 67.7593 66.1239L69.8703 64.8703L71.1239 62.7593C71.8531 61.5314 73.1687 60.7722 74.596 60.755L77.0509 60.7249L79.192 59.5237C80.4379 58.8254 81.9564 58.8254 83.2015 59.5237Z",
			fill: "#17B26A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.8697 83.6838L71.9908 76.8049C71.6546 76.4687 71.6546 75.9244 71.9908 75.5891L73.2066 74.3732C73.5428 74.037 74.0871 74.037 74.4225 74.3732L79.4776 79.4283L88.832 70.0739C89.1682 69.7377 89.7125 69.7377 90.0478 70.0739L91.2637 71.2898C91.5999 71.626 91.5999 72.1703 91.2637 72.5056L80.0855 83.6838C79.7502 84.02 79.205 84.02 78.8697 83.6838Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_10312_23782",
				x: 24,
				y: 22,
				width: 93.2159,
				height: 122.576,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 2,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect2_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10312_23782",
						result: "effect2_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10312_23782",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_10312_23782",
				x: 63.1472,
				y: 13.1099,
				width: 70.228,
				height: 70.6221,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 11 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 11 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.639437 0 0 0 0 0.639437 0 0 0 0 0.639437 0 0 0 0.27 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_10312_23782",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_dd_10312_23782",
				x: 33,
				y: 12,
				width: 93.2159,
				height: 122.576,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 2,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect2_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10312_23782",
						result: "effect2_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10312_23782",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_d_10312_23782",
				x: 72.1472,
				y: 3.10986,
				width: 70.228,
				height: 70.6221,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 11 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 11 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.639437 0 0 0 0 0.639437 0 0 0 0 0.639437 0 0 0 0.27 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10312_23782"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_10312_23782",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgReviewCompletedIcon;
